import { cn } from "@/lib/utils";
import type { ApiParam } from "@/lib/docs/api";

const ParamsTable = ({ params }: { params: ApiParam[] }) => {
  if (!params.length) return null;

  return (
    <div className="w-full overflow-x-auto rounded-xl border border-[#EFF2FF]">
      <table className="w-full min-w-[560px] border-collapse text-left text-[13px]">
        <thead>
          <tr className="bg-[#F9FBFF] text-[10.5px] font-semibold uppercase tracking-[0.14em] text-[#8B93A7]">
            <th className="px-4 py-2.5 font-semibold">Name</th>
            <th className="px-3 py-2.5 font-semibold">In</th>
            <th className="px-3 py-2.5 font-semibold">Type</th>
            <th className="px-3 py-2.5 font-semibold">Required</th>
            <th className="px-4 py-2.5 font-semibold">Description</th>
          </tr>
        </thead>
        <tbody>
          {params.map((param) => (
            <tr key={param.name} className="border-t border-[#EFF2FF] align-top">
              <td
                className={cn(
                  "whitespace-nowrap px-4 py-3 font-mono text-[12px] text-[#101828]",
                  param.depth > 0 && "text-[#525866]",
                )}
                style={{ paddingLeft: `${16 + param.depth * 14}px` }}
              >
                {param.name}
              </td>
              <td className="px-3 py-3 font-mono text-[11.5px] text-[#525866]">{param.in}</td>
              <td className="whitespace-nowrap px-3 py-3 font-mono text-[11.5px] text-[#525866]">
                {param.type}
              </td>
              <td className="px-3 py-3 text-[12px] text-[#525866]">
                {param.required ? "Yes" : "No"}
              </td>
              <td className="px-4 py-3 leading-[1.6] text-[#525866]">
                {param.description}
                {param.constraints && <span> {param.constraints}</span>}
                {param.default !== null && (
                  <span className="block font-mono text-[11.5px] text-[#8B93A7]">
                    default {String(param.default)}
                  </span>
                )}
                {param.options && (
                  <span className="mt-1 flex flex-wrap gap-1">
                    {param.options.map((option) => (
                      <span
                        key={option}
                        className="rounded bg-[#F9FBFF] px-1.5 py-0.5 font-mono text-[11px] text-[#525866]"
                      >
                        {option}
                      </span>
                    ))}
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ParamsTable;
